import classNames from 'classnames';
import { Button, FlexContainer, Input, Txt } from 'components';
import { useState } from 'react';
import { functions } from 'firebaseSDK';
import styles from './LinkToTenancy.module.scss';

/**
 * LinkToTenancy
 *
 * @return {JSX.Element}
 */
const LinkToTenancy = ({ className, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [codeValue, setCodeValue] = useState('');
  const [error, setError] = useState('');
  const handleCodeChange = ({ target: { value } }) => setCodeValue(value);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    functions.tenancy
      .linkToATenancy({
        linkingCode: codeValue.trim(),
      })
      .then(({ data }) => {
        const status = data?.status;
        if (status === 'invalidCode') {
          setError('Invalid code');
          setIsLoading(false);
        } else if (status === 'error') {
          setError('Unknown error');
          setIsLoading(false);
        } else {
          if (onSuccess) {
            onSuccess();
          } else {
            setIsLoading(false);
          }
        }
      })
      .catch((e) => {
        console.warn('Failed to link tenancy');
        console.error(e);
        setIsLoading(false);
      });
    console.log('Submit code', codeValue);
  };

  return (
    <form onSubmit={handleSubmit}>
      <FlexContainer
        className={classNames(
          styles.LinkToTenancy,
          className,
          LinkToTenancy.displayName
        )}
        column
        gap
      >
        <Txt regular>
          You will have received an email with a linking code from your
          landlord.
        </Txt>
        <Txt regular>
          Enter below to link to your tenancy. Then tap 'Link to your Tenancy'.
        </Txt>
        <FlexContainer column gapHalf>
          <Txt bold x>
            Linking code
          </Txt>
          <Input
            value={codeValue}
            onChange={handleCodeChange}
            name="code"
            flex
            reverse
            placeholder="POSCOE12345678"
            maxLength="44"
            minLength="8"
            required
            disabled={isLoading}
          />
        </FlexContainer>
        {error ? <Txt error>{error}</Txt> : null}
        <Button success type="submit" disabled={isLoading}>
          Link to your Tenancy
        </Button>
      </FlexContainer>
    </form>
  );
};

LinkToTenancy.displayName = 'LinkToTenancy';

export default LinkToTenancy;
